import { baseProdConfig } from "./baseEnv";

export const orthoEMotionProdConfig = {
  ...baseProdConfig,
}